<template>
  <v-layout>
    <v-container grid-list-lg>
      <v-layout row wrap class="feature">
        <v-flex sm12 md4 class="feature_box"  v-for="(feature,index) in features" :key="index">
          <v-card>
            <v-layout row wrap>
              <v-flex sm12 md4 lg3 class="pa-0">
                <div class="icn_box">
                  <v-icon x-large class="discount" >{{feature.icon}}</v-icon>
                </div>
              </v-flex>
              <v-flex sm12 md8 lg9 class="py-0">
                <v-card-title primary-title>
                  <div class="feature_headline">{{feature.title}}</div>
                </v-card-title>
                <v-card-text>
                  <p>{{feature.text}}</p> 
                </v-card-text>
              </v-flex>
            </v-layout>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </v-layout>
</template>

<script>
  import firebase from "firebase";
  import moment from 'moment'
  export default {
    name:'Feature',  
    data(){
      return{
        features:[]
      }
    }, 
    created(){
      var db = firebase.firestore();   

      // Show All Features
      let cref = db.collection('features').orderBy('timestamp', 'desc')

      cref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc
            this.features.push({
              id:doc.id,                      
              title:doc.data().title,            
              icon:doc.data().icon,            
              text:doc.data().text,
              timestamp:moment(doc.data().timestamp).format('ll'),  
            })
          }
        })
      })
    },  
  }
</script>

<style scoped>
.v-card {  
  line-height: 22px;
} 

 .v-card__text {
  padding: 0px;
}
 .v-card__title {
  padding:0px 0 0;
}
.feature  .v-card{
  padding:35px!important;
  width:100%!important;
  background: #4A8B71;
  height:100%;
  cursor: pointer;
  box-shadow: 0px 3px 15px 0px rgba(226, 226, 226, 0.75);
}

.feature  .v-card:hover{
  box-shadow: 0px 3px 15px 0px rgba(42, 40, 40, 0.75);
}



.feature .feature_box:nth-of-type(2) .v-card{
  background: #baa054;
}
.feature .feature_box:nth-of-type(3) .v-card{
    background: #b15a5e;
}

.feature .feature_box .discount{
   width:100%;
  height:100%;
  position: relative;
  font-size: 50px;
  color:#FAFAFA;
  font-weight: 600;
  z-index: 111;
  transition:all 0.5s;
}
.feature_box :hover .icn_box{
background: #FAFAFA;

}
.feature_box:nth-of-type(1):hover .discount{
  color:#4A8B71!important;
}
.feature_box:nth-of-type(2):hover .discount{
  color:#baa054!important;
}
.feature_box:nth-of-type(3):hover .discount{
  color:#b15a5e!important;
}

.feature .feature_headline{
  font-size:20px!important;
  font-weight: bold;
  width:100%;
  font-size: 20px !important;
  margin: 0px 0 15px !important;
  color:#FAFAFA !important;
  font-family: 'Lobster Two', cursive;
}
 @media (max-width:959px){
   .feature .feature_headline{
      margin:15px 0!important;
   }
   .icn_box{
     margin-left: 10px;
   }
 }
.feature p{
  margin-bottom: 0;
  color:#FAFAFA !important;
  line-height: 1.5rem;
  text-align: justify;
}

.icn_box{
  width:65px;
  height:65px;
  text-align: center;
  border:2px solid #FAFAFA;
  border-radius: 4px;
  transition:all 0.5s;
}


</style>


// WEBPACK FOOTER //
// src/components/shop/sections/Feature.vue